module.exports = "/assets/data/afc9fbd7e46177521464d9f4f1dc48a2-GL53.data.json";